module.exports = "<div [ngStyle]=\"getDivStyle()\">\r\n  <p class=\"card-text small msg-format\">\r\n    <span>{{ getValue() }}</span>\r\n  </p>\r\n</div>\r\n"